import mapLabelToComponent from "@/portals/(shared)/helpers/mapLabelToComponent";

export function mapRouteOptions(url, isPcp, isCaseManagerOrPeer) {
  if (isPcp) {
    return [
      {
        activeIconComponent: mapLabelToComponent("Dashboard", true),
        icon: "NavMenu__dashboard-icon",
        iconComponent: mapLabelToComponent("Dashboard"),
        label: "Dashboard",
        mobileIcon: "dashboard.svg",
        route: url + "/home",
      },
      {
        activeIconComponent: mapLabelToComponent("Patients", true),
        icon: "NavMenu__patients-icon",
        iconComponent: mapLabelToComponent("Patients"),
        label: "Patients",
        mobileIcon: "patients.svg",
        route: url + "/patient",
      },
      {
        activeIconComponent: mapLabelToComponent("Patients", true),
        icon: "NavMenu__patients-icon",
        iconComponent: mapLabelToComponent("Patients"),
        label: "Add New Patient",
        mobileIcon: "add_new.svg",
        mobileOnly: true,
        route: url + "/patient/add",
      },
      {
        activeIconComponent: mapLabelToComponent("Screening", true),
        icon: "NavMenu__screening-icon",
        iconComponent: mapLabelToComponent("Screening"),
        label: "Screening",
        mobileIcon: "screening.svg",
        permissionKey: "screening",
        route: url + "/a5_screenings",
      },
      {
        activeIconComponent: mapLabelToComponent("Reports", true),
        icon: "NavMenu__reports-icon",
        iconComponent: mapLabelToComponent("Reports"),
        label: "Reports",
        mobileIcon: "reports.svg",
        permissionKey: "reports",
        route: url + "/reports",
      },
      {
        activeIconComponent: mapLabelToComponent("Settings", true),
        icon: "NavMenu__settings-icon",
        iconComponent: mapLabelToComponent("Settings"),
        label: "Settings",
        mobileIcon: "settings.svg",
        route: url + "/settings",
      },
    ];
  }

  if (isCaseManagerOrPeer) {
    return [
      {
        activeIconComponent: mapLabelToComponent("Patients", true),
        icon: "NavMenu__patients-icon",
        iconComponent: mapLabelToComponent("Patients"),
        label: "Patients",
        mobileIcon: "patients.svg",
        route: url + "/patient",
      },
      {
        activeIconComponent: mapLabelToComponent("Calendar", true),
        iconComponent: mapLabelToComponent("Calendar"),
        label: "Calendar",
        route: url + "/schedule",
      },
      {
        activeIconComponent: mapLabelToComponent("Reports", true),
        icon: "NavMenu__reports-icon",
        iconComponent: mapLabelToComponent("Reports"),
        label: "Reports",
        mobileIcon: "reports.svg",
        permissionKey: "reports",
        route: url + "/reports",
      },
      {
        activeIconComponent: mapLabelToComponent("Messages", true),
        iconComponent: mapLabelToComponent("Messages"),
        label: "Messages",
        route: url + "/messages",
      },
    ];
  }

  return [
    {
      activeIconComponent: mapLabelToComponent("Dashboard", true),
      icon: "NavMenu__dashboard-icon",
      iconComponent: mapLabelToComponent("Dashboard"),
      label: "Dashboard",
      mobileIcon: "dashboard.svg",
      route: url + "/home",
    },
    {
      activeIconComponent: mapLabelToComponent("Patients", true),
      icon: "NavMenu__patients-icon",
      iconComponent: mapLabelToComponent("Patients"),
      label: "Patients",
      mobileIcon: "patients.svg",
      route: url + "/patient",
    },
    {
      activeIconComponent: mapLabelToComponent("Reports", true),
      icon: "NavMenu__reports-icon",
      iconComponent: mapLabelToComponent("Reports"),
      label: "Reports",
      mobileIcon: "reports.svg",
      permissionKey: "reports",
      route: url + "/reports",
    },
    {
      activeIconComponent: mapLabelToComponent("Calendar", true),
      iconComponent: mapLabelToComponent("Calendar"),
      label: "Calendar",
      route: url + "/schedule",
    },
    {
      activeIconComponent: mapLabelToComponent("Messages", true),
      iconComponent: mapLabelToComponent("Messages"),
      label: "Messages",
      route: url + "/messages",
    },
  ];
}
